import * as React from 'react';
import { useNavigate } from 'react-router';

import { Button } from '@independent-software/typeui/controls/Button';
import { Icon } from '@independent-software/typeui/controls/Icon';

import { AuthContext } from '../../AuthContext';
import { FilterContext } from '../../FilterContext';
import { Container, Content, BottomBar } from '../../modules';
import { Sample } from '../../resource/';
import { ListSamples } from './ListSamples';
import { Gate } from '../../controls/Gate';

const SampleList = () => {
  const auth = React.useContext(AuthContext);
  const filter = React.useContext(FilterContext);
  const navigate = useNavigate();

  // Go to add sample view.
  const handleAdd = () => {
    navigate('/samples/add');
  }  

  // Go to view sample view.
  const handleClick = (item: Sample) => {
    navigate(`/samples/${item.id}`);
  }  

  return (
    <Container>
      <Content>
        <ListSamples auth={auth} filter={filter} name="samples" onClick={handleClick}/>
      </Content>
      <BottomBar>
        <Gate right='can_edit_samples'>
          <Button primary onClick={handleAdd}><Icon name="plus"/> Add sample</Button>
        </Gate>
      </BottomBar>
    </Container>
  );
}

export { SampleList }
